import React from 'react';

const BranchCard = ({link, color, title, carPrice, pufPrice}) => {
  return (
    <div className={`  border border-${color} rounded-[12px]`}>
        <p className={`text-${color} text-[24px] font-semibold text-center p-2`}>
        {title}
      </p>
      <div className=' h-[400px]'>
      <iframe
        src={link}
        width="100%"
        height="100%"
        style={{ border: "none" }}
        allowFullScreen
        title="Waze Map"
      ></iframe>
      </div>
      <p className='text-white font-semibold p-2 text-center'>{carPrice}</p>
      <p>{pufPrice}</p>
      
    </div>
  );
}

export default BranchCard;
